<template>
  <div class="col-md-6" v-for="(element, index) in creative" :key="index">
    <div class="card" :class="element.card">
      <div class="card-header" :class="element.header">
        <h3 :class="element.class">{{ element.title }}</h3>
      </div>
      <div class="card-body">
        <p>{{ element.desc }}</p>
      </div>
    </div>
  </div>
</template>
<script >
import card from "@/data/card.json"
export default {
  data() {
    return {
      creative: card.creative
    }
  }
}
</script>